import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const token = () => localStorage.getItem('session_token');
const auth = () => ({ Authorization: `Bearer ${token()}` });

export const commsApi = {
  conversations: () => axios.get(`${API}/messages/conversations`, { headers: auth() }).then((r) => r.data),
  history: (userId, before) => axios.get(`${API}/messages/direct/${userId}`, { headers: auth(), params: before ? { before } : {} }).then((r) => r.data),
  channelHistory: (teamId, before) => axios.get(`${API}/channels/${teamId}/messages`, { headers: auth(), params: before ? { before } : {} }).then((r) => r.data),
  search: (params, signal) => axios.get(`${API}/messages/search`, { headers: auth(), params, signal }).then((r) => r.data.results),
  react: (messageId, emoji) => axios.post(`${API}/messages/${messageId}/reactions`, { emoji }, { headers: auth() }).then((r) => r.data),
  setPassword: (password, confirmPassword) => axios.post(`${API}/auth/set-password`, { password, confirm_password: confirmPassword }, { headers: auth() }).then((r) => r.data),
  changePassword: (currentPassword, newPassword, confirmPassword) => axios.post(`${API}/auth/change-password`, { current_password: currentPassword, new_password: newPassword, confirm_password: confirmPassword }, { headers: auth() }).then((r) => r.data),
  toggleSubtask: (taskId, index, done) => axios.patch(`${API}/tasks/${taskId}/subtasks/${index}`, { done }, { headers: auth() }).then((r) => r.data),
  voiceTaskDrafts: (teamId, { file, transcript, language } = {}) => {
    const form = new FormData();
    form.append('team_id', teamId);
    if (file) form.append('file', file);
    if (transcript) form.append('transcript', transcript);
    if (language) form.append('language', language);
    return axios.post(`${API}/tasks/voice-drafts`, form, { headers: auth() }).then((r) => r.data);
  },
  createTask: (task) => axios.post(`${API}/tasks`, task, { headers: auth() }).then((r) => r.data),
  teamMembers: (teamId) => axios.get(`${API}/teams/${teamId}/members`, { headers: auth() }).then((r) => r.data),
  transcribe: (file, language) => {
    const form = new FormData();
    form.append('file', file);
    if (language) form.append('language', language);
    return axios.post(`${API}/transcribe`, form, { headers: auth() }).then((r) => r.data);
  },
  linkGoogle: (sessionId) => axios.post(`${API}/auth/google/link`, { session_id: sessionId }, { headers: auth() }).then((r) => r.data),
  unlinkGoogle: () => axios.delete(`${API}/auth/google/link`, { headers: auth() }).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`, { headers: auth() }).then((r) => r.data),
  markRead: (userId) => axios.post(`${API}/messages/direct/${userId}/read`, {}, { headers: auth() }),
  markChannelRead: (teamId) => axios.post(`${API}/channels/${teamId}/read`, {}, { headers: auth() }),
  unreadCount: () => axios.get(`${API}/messages/unread-count`, { headers: auth() }).then((r) => r.data.count),
  send: (payload) => axios.post(`${API}/messages/direct`, payload, { headers: auth() }).then((r) => r.data),
  sendChannel: (teamId, payload) => axios.post(`${API}/channels/${teamId}/messages`, payload, { headers: auth() }).then((r) => r.data),
  upload: (file, { toUserId, teamId, duration, onProgress } = {}) => {
    const form = new FormData();
    form.append('file', file);
    if (toUserId) form.append('to_user_id', toUserId);
    if (teamId) form.append('team_id', teamId);
    if (duration != null) form.append('duration', String(duration));
    return axios
      .post(`${API}/files/upload`, form, {
        headers: auth(),
        onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
      })
      .then((r) => r.data);
  },
  fileUrl: (fileId) => `${API}/files/${fileId}/download?auth=${token()}`,
  markPlayed: (messageId) => axios.post(`${API}/messages/${messageId}/played`, {}, { headers: auth() }).then((r) => r.data),
  pushPublicKey: () => axios.get(`${API}/push/public-key`).then((r) => r.data),
  pushSubscribe: (subscription, mutedTeamIds) => axios.post(`${API}/push/subscribe`, {
    ...subscription, muted_team_ids: mutedTeamIds, user_agent: navigator.userAgent,
  }, { headers: auth() }),
  pushUnsubscribe: (endpoint) => axios.delete(`${API}/push/subscribe`, { data: { endpoint }, headers: auth() }),
  quietHours: () => axios.get(`${API}/users/me/quiet-hours`, { headers: auth() }).then((r) => r.data),
  saveQuietHours: (qh) => axios.put(`${API}/users/me/quiet-hours`, qh, { headers: auth() }).then((r) => r.data),
};

export const wsUrl = (userId) =>
  `${BACKEND_URL.replace(/^http/, 'ws')}/api/ws/${userId}?token=${token()}`;
